// extracted by css-extract-rspack-plugin
export default {"author":"Uuk1rngQwcb82yD9"};